import apiService from 'apiService'
import React from 'react'
import Swal from 'sweetalert2'

export default function DeleteStoreIcon({ storeId, refreshTable }) {
    const handleClick = async () => {
        Swal.fire({
            icon: 'question',
            title: 'Διαγραφή καταστήματος?',
            text: `Σίγουρα θέλετε να διαγράψετε το κατάστημα ${storeId}?`,
            showCancelButton: true,
            confirmButtonText: 'ΔΙΑΓΡΑΦΗ',
            confirmButtonColor: 'red',
            cancelButtonText: 'ΑΚΥΡΟ'
        }).then(async result => {
            if (!result.isConfirmed) return
            await apiService.delete(`/stores/${storeId}`)
            refreshTable(+Date.now())
            Swal.fire({
                icon: 'success',
                title: 'Επιτυχία!',
                text: `Επιτυχής διαγραφή καταστήματος!`,
                showCancelButton: false,
                confirmButtonText: 'ΟΚ',
                confirmButtonColor: '#51a351',
                cancelButtonText: 'ΑΚΥΡΟ'
            })
        })
    }

    return <i title="Διαγραφή Καταστήματος" className="fas fa-trash text-red-500 mr-2" style={{ cursor: 'pointer' }} onClick={handleClick}></i>
}
